import React from "react";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import { Link, useNavigate } from "react-router-dom";
import Icon from "@mui/material/Icon";
import MDButton from "../../components/MDButton";

export default function DefinitionPage() {
  const definitions = [
    { id: 1, name: "دستگاه", link: "/machines" },
    { id: 2, name: "نوع دستگاه", link: "/machine-types" },
    { id: 3, name: "گروه دستگاه", link: "/machine-group" },
    { id: 4, name: "راننده", link: "/drivers" },
    { id: 5, name: "مبدا", link: "/origin" },
    { id: 6, name: "مقصد", link: "/destination" },
    { id: 7, name: "کالا", link: "/jens" },
    { id: 8, name: "تجهیز بارگیری", link: "/equipments" },
    { id: 9, name: "کد کالا", link: "/jensCodes" },
    { id: 10, name: "اپراتور", link: "/operators" },
    { id: 11, name: "محل استقرار", link: "/locations" },
    { id: 12, name: "پیمانکار", link: "/peymankar" },
    { id: 13, name: "پروژه", link: "/projects" },
    { id: 14, name: "وزن", link: "/weights" },
    { id: 14, name: "تاخیر", link: "/delays" },
    { id: 15, name: "نقص فنی", link: "/defects" },
    { id: 16, name: "شیفت", link: "/shifts" },
    { id: 16, name: "مشتری", link: "/purchasor" },
  ];
  const navigate = useNavigate();

  return (
      <div
        className="min-h-screen bg-gradient-to-br from-white to-gray-100 flex items-center justify-center relative overflow-hidden">
        {/* Decorative Background Shapes */}
        <div
          className="absolute w-[400px] h-[400px] bg-gradient-to-tr from-blue-200 to-blue-400 rounded-full blur-3xl opacity-30 top-0 left-10"></div>
        <div
          className="absolute w-[300px] h-[300px] bg-gradient-to-bl from-green-200 to-green-400 rounded-full blur-3xl opacity-30 bottom-10 right-10"></div>

        {/* Main Content */}
        <div className="relative z-10 bg-white shadow-2xl rounded-3xl p-10 max-w-3xl w-full border border-gray-200">
          <MDButton
            variant="text"
            color="dark"
            onClick={() => navigate(-1)}
          >
            <Icon sx={{ mr: 1,ml:1 }}>arrow_forward</Icon>
            بازگشت
          </MDButton>
          <h1 className="text-3xl font-bold text-center text-gray-700 mb-8">
            ثبت تعاریف
          </h1>
          <div className="grid grid-cols-3 gap-6">
            {definitions.map((item) => (
              <Link
                key={item.id}
                to={item.link}
                className="group relative p-6 rounded-2xl bg-gradient-to-r from-gray-100 to-gray-50 hover:from-blue-100 hover:to-blue-50 shadow-md transition-all duration-300 transform hover:scale-105 flex items-center justify-center"
              >
              <span className="text-lg font-semibold text-gray-700 group-hover:text-blue-600 transition-colors">
                {item.name}
              </span>
                <div
                  className="absolute inset-0 rounded-2xl bg-white/50 opacity-0 group-hover:opacity-20 transition-all duration-300"></div>
              </Link>
            ))}
          </div>
        </div>
      </div>
  );
}
